import React from "react";
import { Button, Heading, Copy } from "components/components/atoms";
import PropTypes from "prop-types";
import cx from "classnames";
import styled from "styled-components";
import { isValidTitle } from "utils/validateTitle";

const StyledCopy = styled(Copy)`
  overflow-wrap: break-word;
  word-break: normal;
`;
const StyledButton = styled(Button)`
  overflow-wrap: break-word;
  word-break: normal;
  &:hover {
    ${({ showNewSchemaColor, color }) =>
      showNewSchemaColor && `background-color: ${color};`}
    ${({ showNewSchemaColor, newSchemaTextColorHexaCode }) =>
      showNewSchemaColor && `color: ${newSchemaTextColorHexaCode};`}
  }
`;

const hasCTA = (ctas) => ctas.some((cta) => cta && cta.text);

const ContentBlock = ({
  textColor = "white",
  heading = "",
  copy = "",
  ctas = [],
  ButtonProps = {},
  className = "",
  cutOffTitle = true,
  registerPromo = false,
  showNewSchemaColor = false,
  newSchemaColorHexaCode = "",
  newSchemaTextColorHexaCode = "",
  isMobile = false,
}) => {
  const withCTA = hasCTA(ctas);
  return (
    <div className={cx("flex flex-col items-start", className)}>
      {isValidTitle(heading) && (
        <Heading
          as="h2"
          color={showNewSchemaColor ? newSchemaTextColorHexaCode : textColor}
          className="leading-tiny"
        >
          {cutOffTitle && heading && heading.length > 37
            ? heading.substring(0, 36) + "..."
            : heading}
        </Heading>
      )}
      {copy ? (
        <StyledCopy
          color={showNewSchemaColor ? newSchemaTextColorHexaCode : textColor}
          className={cx("leading-relaxed break-all w-full list-inside", {
            "mb-30-mattamy": withCTA,
            "md:mb-0": !withCTA,
          })}
        >
          {copy}
        </StyledCopy>
      ) : (
        ""
      )}

      <div className="w-full">
        {ctas.map(
          (cta) =>
            cta &&
            cta.text && (
              <StyledButton
                key={cta.text}
                variant={
                  showNewSchemaColor
                    ? isMobile
                      ? "filled"
                      : "outlined"
                    : ButtonProps.variant || "outlined"
                }
                color={
                  showNewSchemaColor
                    ? newSchemaColorHexaCode
                    : ButtonProps.color || "white"
                }
                textColor={
                  showNewSchemaColor
                    ? newSchemaTextColorHexaCode
                    : ButtonProps.textColor || "white"
                }
                className={cx("mb-4 mr-4 truncate", ButtonProps.className, {})}
                showNewSchemaColor={showNewSchemaColor}
                newSchemaTextColorHexaCode={newSchemaTextColorHexaCode}
                href={cta.href}
                target={cta.target}
                linkWrapperDescription={cta.text}
                onClick={() => {
                  if (registerPromo)
                    window.dataLayer.push({ event: "view-promotion" });
                }}
                buttonDescription={cta.text}
              >
                {cta.text}
              </StyledButton>
            )
        )}
      </div>
    </div>
  );
};

ContentBlock.propTypes = {
  textColor: PropTypes.string,
  heading: PropTypes.string,
  copy: PropTypes.string,
  ButtonProps: PropTypes.object,
  ctas: PropTypes.arrayOf(PropTypes.object),
};

export default ContentBlock;
